import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { HeaderState, HeaderTypes } from './types';

const INITIAL_STATE: HeaderState = {
    show: true,
    showMenu: true,
};

const reducer: Reducer<HeaderState> = (state: HeaderState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case HeaderTypes.SHOW_HEADER:
            return { ...state, show: true };
        case HeaderTypes.HIDE_HEADER:
            return { ...state, show: false };
        case HeaderTypes.SHOW_HEADER_MENU:
            return { ...state, showMenu: true };
        case HeaderTypes.HIDE_HEADER_MENU:
            return { ...state, showMenu: false };
        default:
            return state;
    }
};

export default reducer;
